'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var mkdir = require('./mkdir');

var stat = require('./stat');

var log = require('debug')('ipfs:mfs:cp');

var errCode = require('err-code');

var updateTree = require('./utils/update-tree');

var updateMfsRoot = require('./utils/update-mfs-root');

var addLink = require('./utils/add-link');

var applyDefaultOptions = require('./utils/apply-default-options');

var toMfsPath = require('./utils/to-mfs-path');

var toSourcesAndDestination = require('./utils/to-sources-and-destination');

var toTrail = require('./utils/to-trail');

var defaultOptions = {
  parents: false,
  flush: true,
  hashAlg: 'sha2-256',
  cidVersion: 0,
  shardSplitThreshold: 1000
};

module.exports = function (context) {
  return /*#__PURE__*/function () {
    var _mfsCp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _len,
          args,
          _key,
          options,
          _yield$toSourcesAndDe,
          sources,
          destination,
          missing,
          destinationIsDirectory,
          parentFolder,
          destinationPath,
          trail,
          source,
          destinationName,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args[_key];
              }

              options = applyDefaultOptions(args, defaultOptions);
              _context.next = 4;
              return toSourcesAndDestination(context, args);

            case 4:
              _yield$toSourcesAndDe = _context.sent;
              sources = _yield$toSourcesAndDe.sources;
              destination = _yield$toSourcesAndDe.destination;

              if (sources.length) {
                _context.next = 9;
                break;
              }

              throw errCode(new Error('Please supply at least one source'), 'ERR_INVALID_PARAMS');

            case 9:
              options.parents = options.p || options.parents; // make sure all sources exist

              missing = sources.find(function (source) {
                return !source.exists;
              });

              if (!missing) {
                _context.next = 13;
                break;
              }

              throw errCode(new Error("".concat(missing.path, " does not exist")), 'ERR_INVALID_PARAMS');

            case 13:
              destinationIsDirectory = isDirectory(destination);

              if (!destination.exists) {
                _context.next = 20;
                break;
              }

              log('Destination exists');

              if (!(sources.length === 1 && !destinationIsDirectory)) {
                _context.next = 18;
                break;
              }

              throw errCode(new Error('directory already has entry by that name'), 'ERR_ALREADY_EXISTS');

            case 18:
              _context.next = 49;
              break;

            case 20:
              log('Destination does not exist');

              if (!(sources.length > 1)) {
                _context.next = 31;
                break;
              }

              if (options.parents) {
                _context.next = 24;
                break;
              }

              throw errCode(new Error('destination did not exist, pass -p to create intermediate directories'), 'ERR_INVALID_PARAMS');

            case 24:
              _context.next = 26;
              return mkdir(context)(destination.path, options);

            case 26:
              _context.next = 28;
              return toMfsPath(context, destination.path);

            case 28:
              destination = _context.sent;
              _context.next = 49;
              break;

            case 31:
              if (!(destination.parts.length > 1)) {
                _context.next = 49;
                break;
              }

              // copying to a folder, create it if necessary
              parentFolder = "/".concat(destination.parts.slice(0, -1).join('/'));
              _context.prev = 33;
              _context.next = 36;
              return stat(context)(parentFolder, options);

            case 36:
              _context.next = 49;
              break;

            case 38:
              _context.prev = 38;
              _context.t0 = _context["catch"](33);

              if (!(_context.t0.code !== 'ERR_NOT_FOUND')) {
                _context.next = 42;
                break;
              }

              throw _context.t0;

            case 42:
              if (options.parents) {
                _context.next = 44;
                break;
              }

              throw errCode(new Error('destination did not exist, pass -p to create intermediate directories'), 'ERR_INVALID_PARAMS');

            case 44:
              _context.next = 46;
              return mkdir(context)(parentFolder, options);

            case 46:
              _context.next = 48;
              return toMfsPath(context, destination.path);

            case 48:
              destination = _context.sent;

            case 49:
              destinationPath = isDirectory(destination) ? destination.mfsPath : destination.mfsDirectory;
              _context.next = 52;
              return toTrail(context, destinationPath, options);

            case 52:
              trail = _context.sent;

              if (!(sources.length === 1)) {
                _context.next = 58;
                break;
              }

              source = sources.pop();
              destinationName = destinationIsDirectory ? source.name : destination.name;
              log("Only one source, copying to destination ".concat(destinationIsDirectory ? 'directory' : 'file', " ").concat(destinationName));
              return _context.abrupt("return", copyToFile(context, source, destinationName, trail, options));

            case 58:
              log('Multiple sources, wrapping in a directory');
              return _context.abrupt("return", copyToDirectory(context, sources, destination, trail, options));

            case 60:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[33, 38]]);
    }));

    function mfsCp() {
      return _mfsCp.apply(this, arguments);
    }

    return mfsCp;
  }();
};

var isDirectory = function isDirectory(destination) {
  return destination.unixfs && destination.unixfs.type && destination.unixfs.type.includes('directory');
};

var copyToFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, source, destination, destinationTrail, options) {
    var parent, newRootCid;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            parent = destinationTrail.pop();
            _context2.next = 3;
            return addSourceToParent(context, source, destination, parent, options);

          case 3:
            parent = _context2.sent;
            // update the tree with the new containing directory
            destinationTrail.push(parent);
            _context2.next = 7;
            return updateTree(context, destinationTrail, options);

          case 7:
            newRootCid = _context2.sent;
            _context2.next = 10;
            return updateMfsRoot(context, newRootCid);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function copyToFile(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

var copyToDirectory = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, sources, destination, destinationTrail, options) {
    var i, source, newRootCid;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < sources.length)) {
              _context3.next = 9;
              break;
            }

            source = sources[i];
            _context3.next = 5;
            return addSourceToParent(context, source, source.name, destination, options);

          case 5:
            destination = _context3.sent;

          case 6:
            i++;
            _context3.next = 1;
            break;

          case 9:
            // update the tree with the new containing directory
            destinationTrail[destinationTrail.length - 1] = destination;
            _context3.next = 12;
            return updateTree(context, destinationTrail, options);

          case 12:
            newRootCid = _context3.sent;
            _context3.next = 15;
            return updateMfsRoot(context, newRootCid);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function copyToDirectory(_x6, _x7, _x8, _x9, _x10) {
    return _ref2.apply(this, arguments);
  };
}();

var addSourceToParent = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, source, childName, parent, options) {
    var sourceBlock, _yield$addLink, node, cid;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return context.repo.blocks.get(source.cid);

          case 2:
            sourceBlock = _context4.sent;
            _context4.next = 5;
            return addLink(context, {
              parentCid: parent.cid,
              size: sourceBlock.data.length,
              cid: source.cid,
              name: childName,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion,
              flush: options.flush
            });

          case 5:
            _yield$addLink = _context4.sent;
            node = _yield$addLink.node;
            cid = _yield$addLink.cid;
            parent.node = node;
            parent.cid = cid;
            parent.size = node.size;
            return _context4.abrupt("return", parent);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function addSourceToParent(_x11, _x12, _x13, _x14, _x15) {
    return _ref3.apply(this, arguments);
  };
}();